import { useFormContext } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import { InfoNotice } from "../../shared/uikit/Notice/InfoNotice";
import { Typography } from "../../shared/uikit/Typography";

interface EmailSuggestionProps {
  suggestedEmail: string;
}

const localeScope = "authentication_app.signup";

const EmailSuggestion = ({ suggestedEmail }: EmailSuggestionProps) => {
  const { setValue } = useFormContext();
  return (
    <InfoNotice className="!bg-selector-active border-hover !mt-3">
      <Typography.BodySm color="text-dark" weight="semibold" as="span">
        {t(`${localeScope}.form.did_you_mean`)}{" "}
        <button
          type="button"
          onClick={() => {
            setValue("user[email]", suggestedEmail, {
              shouldValidate: true,
              shouldDirty: true,
            });
          }}
          className="text-brand hover:text-brand-dark ms-1 underline"
        >
          {suggestedEmail}
        </button>
        {" ?"}
      </Typography.BodySm>
    </InfoNotice>
  );
};

export default EmailSuggestion;
